import config from './config'
import { handleResponse } from './handle-response'
import { checkToken, authHeader } from './helpers'

export const premiumReports = {
    details,
	delete_report
}

async function details() {

    await checkToken()

    const requestOptions = { method: 'GET', headers: authHeader()}
    return fetch(`${config.apiUrl}/premium-reports/`, requestOptions)
        .then(handleResponse)
        .then(user => {
            return user
        })
}

async function delete_report(report_id) {

    await checkToken()

    const requestOptions = { method: 'DELETE', headers: authHeader()}
    return fetch(`${config.apiUrl}/premium-reports/${report_id}/`, requestOptions)
        .then(handleResponse)
        .then(user => {
            return user
        })
}
